export class CustomerAffiliationMember {
    public id: number;
    public customerAffiliationId: number;
    public customerAffiliationRoleTypeId: number;
    public customerAffiliationRoleTypeDisplayValue: string;
    public customerNumberID: number;
    public customerName: string;
    public customerTypeId: number;
    public isPrimary: boolean;
    public effectiveDate: any;
    public endDate: any;
}
